export const experience = [
  {
    company: "The Strelema",
    title: "Artificial Intelligence Engineer",
    location: "Pune City",
    start: "Apr 2025",
    end: "Present",
    description: "Built a social media civilian pain-point dashboard to surface public sentiment and issues, alongside an AI voice calling agent for automated outreach."
  },
  {
    company: "Rupadi International",
    title: "AI Engineer",
    location: "Pune",
    start: "Mar 2025",
    end: "Apr 2025",
    description: "Built an AI calling agent and an AI interview agent that conducts L1 and L2 candidate interview rounds, generating a 360° evaluation report for each candidate."
  },
  {
    company: "Bajaj Finserv (via TeamLease)",
    title: "Jr Data Scientist",
    location: "Pune",
    start: "Aug 2024",
    end: "Dec 2024",
    description: "Analyzed large datasets with SQL and Python, built automated Tableau reports and dashboards, and worked with cross-functional teams to track key business metrics."
  },
  {
    company: "Collegedunia",
    title: "Data Research Analyst",
    location: "Pune, Maharashtra, India",
    start: "Mar 2023",
    end: "May 2024",
    description: "Extracted and SEO-optimized college data via web scraping, then published it to drive organic traffic on the website."
  },
  {
    company: "PASM Farm, Dahiwadi",
    title: "Data Analyst",
    location: "Dahiwadi, Maharashtra, India",
    start: "Jan 2022",
    end: "Feb 2023",
    description: "Conducted data mining and analysis to find cost-saving opportunities, and built data-driven sales forecasting and customer behavior models."
  }
];
